import { inject,ChangeDetectorRef, Component, Inject, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { RestClient } from "../../../Api/DcoApi/Client/RestClient";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Splash } from "../../../Akte/Controlls/Splash";
import { GeraeteModell } from "../../../Api/DcoApi/Admin/AdminClasses2";
import { ToastService } from "../../../Akte/Services/Toasts/ToastService";
import { AdminCard } from "../Sonstige/AdminCard";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap/modal";

import { PreisHist } from "../../Popups/PreisHist";
import { PriceEdit } from "../../Popups/PriceEdit";

@Component({
  imports: [
    CommonModule,
    Splash,
    FormsModule, AdminCard
  ],
  selector: 'GeraeteModelEdit',
  templateUrl: './GeraeteModelEdit.html',
  standalone: true,
  styleUrl: './GeraeteModelEdit.css'
})
export class GeraeteModelEdit implements OnInit {
  constructor(private cdr: ChangeDetectorRef) {
    this.toastService = inject(ToastService)
  }

  Typen = [
    { Key: 0, Value: "Basisstation"},
    { Key: 1, Value: "Funkknopf" },
    { Key: 2, Value: "Mobilgerät" }
  ]

  toastService: ToastService; 
  ngOnInit(): void {
    this.GetData();
  }

  @Input() Key?: string | null = null;

  Client: RestClient = new RestClient();

  Entry: GeraeteModell | null = null;

  async GetData() {
    if (!this.Key || this.Key == null || this.Key == "0" || isNaN(Number(this.Key)))
      this.Entry = { key: 0 } as GeraeteModell;
    else
      this.Entry = await this.Client.Get<GeraeteModell>(`/Backend/Api/V2/Admin/GeraeteModell/${this.Key}`);
    this.cdr.detectChanges();
  }

  async SaveData() {
    if (this.Entry && this.Entry !== null) {
      if (this.Entry.key == 0)
        this.Entry =  await this.Client.Post<GeraeteModell, GeraeteModell>("/Backend/Api/V2/Admin/GeraeteModell", this.Entry);
      else
        this.Entry =  await this.Client.Put<GeraeteModell, GeraeteModell>(`/Backend/Api/V2/Admin/GeraeteModell`, this.Entry);

      this.toastService.show({ template: this.successTpl, classname: 'bg-success text-light show', delay: 10000 })
    }
  }

  private modalService = inject(NgbModal);

  UpdatePreis() {
    if (!this.Entry || this.Entry == null)
      return;

    var modal = this.modalService.open(PriceEdit)
    modal.componentInstance.url = `/Backend/Api/V2/Admin/GeraeteModell/${this.Key}/Rate`;
    modal.componentInstance.header = 'Rate';
    modal.componentInstance.labelText = 'Rate';
    modal.componentInstance.CurrentPrice = this.Entry.rate;

    modal.closed.subscribe({
      next: async (legs) => {        
        var res = await modal.result
        debugger;
        if (res && res != null) {
          if (!(!this.Entry || this.Entry == null)) {
            debugger;
            this.Entry.rate = res.preis;

            var entry = await await this.Client.Get<GeraeteModell>(`/Backend/Api/V2/Admin/GeraeteModell/${this.Key}`);
            this.Entry.rateHistorie = entry.rateHistorie;
            this.cdr.detectChanges();
          }

        }
      },
      error: (err) => {

      },
    });
  }

  OpenPreisHistory() {
    if (!this.Entry || this.Entry == null || !this.Entry.rateHistorie || this.Entry.rateHistorie == null)
      return;
    var modal = this.modalService.open(PreisHist)
    modal.componentInstance.Items = this.Entry.rateHistorie;
    modal.componentInstance.header = 'Historie';
    modal.componentInstance.labelText = 'Rate';

    modal.closed.subscribe({
      next: async (config) => {

      },
      error: (err) => {


      },
    });
  }

  @ViewChild('successTpl') public successTpl!: TemplateRef<any>;
}
